module.exports = __webpack_public_path__ + "images/eye-2f1111.svg";